import React from 'react';
import { FadeIn } from './FadeIn';
import { Heart, ShieldCheck, Clock, Target, Flame } from 'lucide-react';
export function Intro() {
  const objectives = [{
    icon: Heart,
    text: 'Comer más saludable',
    desc: 'Sin ingredientes raros ni dietas imposibles.'
  }, {
    icon: ShieldCheck,
    text: 'Reducir ultraprocesados',
    desc: 'Volvé a la comida real de forma simple.'
  }, {
    icon: Clock,
    text: 'Organizar tus comidas',
    desc: 'Ahorrá tiempo en la cocina todos los días.'
  }, {
    icon: Target,
    text: 'Crear hábitos sostenibles',
    desc: 'Un sistema que no vas a abandonar a la semana.'
  }, {
    icon: Flame,
    text: 'Pérdida de peso gradual',
    desc: 'Lográ resultados sin obsesionarte con las calorías.'
  }];
  return <section className="py-20 bg-white" data-id="element-146">
      <div className="max-w-4xl mx-auto px-4 md:px-6" data-id="element-147">
        <FadeIn data-id="element-148">
          <div className="text-center mb-16" data-id="element-149">
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-stone-900 mb-6" data-id="element-150">
              Antes de empezar, quiero que sepas algo:
            </h2>
            <p className="text-xl md:text-2xl text-brand-600 font-medium mb-4" data-id="element-151">
              Este no es otro recetario más.
            </p>
            <p className="text-lg text-stone-600 max-w-2xl mx-auto" data-id="element-152">
              No vas a encontrar dietas imposibles, ingredientes raros ni planes
              que duran una semana y después abandonás. El objetivo de este
              método es simple:
            </p>
          </div>
        </FadeIn>

        <div className="grid sm:grid-cols-2 gap-4 md:gap-6" data-id="element-153">
          {objectives.map((obj, i) => {
          const Icon = obj.icon;
          return <FadeIn key={i} delay={i * 0.1} data-id="element-154">
                <div className="bg-stone-50 border border-stone-100 p-6 rounded-2xl flex items-start gap-4 hover:shadow-md transition-shadow" data-id="element-155">
                  <div className="bg-brand-100 text-brand-600 p-3 rounded-xl shrink-0" data-id="element-156">
                    <Icon className="w-6 h-6" data-id="element-157" />
                  </div>
                  <div data-id="element-158">
                    <h3 className="font-bold text-stone-900 text-lg mb-1" data-id="element-159">
                      {obj.text}
                    </h3>
                    <p className="text-stone-600 text-sm" data-id="element-160">{obj.desc}</p>
                  </div>
                </div>
              </FadeIn>;
        })}
        </div>
      </div>
    </section>;
}